export const SalesCrm = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_306_10058)">
        <path
          d="M12.1953 12.1953L21.1953 3.19531"
          stroke="black"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.559 5.8318C16.9648 4.24144 14.8319 3.30732 12.582 3.21423C10.3322 3.12115 8.12937 3.87588 6.40933 5.32911C4.68928 6.78235 3.57733 8.82823 3.29343 11.062C3.00954 13.2958 3.57438 15.5548 4.87623 17.3921C6.17808 19.2294 8.1221 20.5112 10.3237 20.9838C12.5253 21.4565 14.8241 21.0856 16.7654 19.9445C18.7066 18.8035 20.1489 16.9754 20.8069 14.8219C21.4649 12.6684 21.2906 10.3464 20.3186 8.31523"
          stroke="black"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.3771 9.01336C14.6327 8.26986 13.6513 7.8107 12.6035 7.71567C11.5557 7.62064 10.5077 7.89575 9.64168 8.49319C8.77566 9.09063 8.14636 9.97263 7.86314 10.9859C7.57992 11.9992 7.66069 13.0796 8.09141 14.0395C8.52213 14.9994 9.27558 15.7781 10.2208 16.2401C11.166 16.7022 12.2432 16.8184 13.2653 16.5686C14.2873 16.3189 15.1895 15.7189 15.8151 14.873C16.4407 14.0271 16.7501 12.9887 16.6896 11.9384"
          stroke="black"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_306_10058">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.195312 0.195312)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
